import React from 'react';

import * as S from './cancellation-reschedule-policy-overlay.styles';

import { CANCELLATION_ID, DATE_CHANGE_ID } from '@stencil/flights-constants';

const CancellationReschedulePolicyTabs = ({
  hasCancellationData,
  hasRescheduleData,
  tabClickHandler,
  activePolicySection
}) => {
  const isCancellationTabActive = activePolicySection === CANCELLATION_ID;

  return (
    <S.PolicyTabsWrap>
      {hasCancellationData && (
        <span
          onClick={() => tabClickHandler(CANCELLATION_ID)}
          className={`policyTab ${isCancellationTabActive ? 'activePolicyTab' : ''}`}
        >
          CANCELLATION CHARGES
        </span>
      )}
      {hasRescheduleData && (
        <span
          onClick={() => tabClickHandler(DATE_CHANGE_ID)}
          className={`policyTab ${!isCancellationTabActive ? 'activePolicyTab' : ''}`}
        >
          RESCHEDULE CHARGES
        </span>
      )}
    </S.PolicyTabsWrap>
  );
};

export default CancellationReschedulePolicyTabs;
